// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles__footer___1wM8Z","footerLogo":"styles__footerLogo___3Im3c"};